import { render } from "./ModalForm.html?vue&type=template&id=26b3b5c6&scoped=true"
import script from "./ModalForm.js?vue&type=script&lang=js"
export * from "./ModalForm.js?vue&type=script&lang=js"

import "./ModalForm.css?vue&type=style&index=0&id=26b3b5c6&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/Shiptech MyPlusRewards/mpr-web-admin-portal/src/MPR.MyPlusRewardsAdminPortal.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b3b5c6"]])

export default __exports__